module.exports = __webpack_public_path__ + "img/no_portrait.0e2be12a.jpeg";